import { CssBaseline, ThemeProvider as MuiThemeProvider } from "@mui/material";
import { lightTheme } from "./lightTheme";
import { darkTheme } from "./darkTheme";
import { useEffect, useState } from "react";

export const ThemeProvider = ({ children }: any) => {
  console.log('🎯 ThemeProvider rendering...');
  const [themeMode, setTheme] = useState(sessionStorage.getItem("themeMode") || "light");

  useEffect(() => {
    const handler = (event: StorageEvent) => {
      const newThemeMode = sessionStorage.getItem("themeMode") || "light";

      setTheme(newThemeMode);
    }
    
    window.addEventListener("storage", handler);

    return () => window.removeEventListener("storage", handler);
  }, []);

  return (
    <MuiThemeProvider theme={themeMode === "light" ? lightTheme : darkTheme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};
